export default "__VITE_ASSET__TiHO$uQ2__"